import React from "react"
import {
  Box, Flex, Heading, Text,
} from "@chakra-ui/react"
import Countdown from "components/elements/Countdown"
import { asDate } from "utilities/strings"
import { DateFormat } from "utilities/constants"

type Props = {
  title: string
  startDate: string
  endDate: string | null
  timezone: string
  venue?: string
  city?: string
}

const EventHeader = ({
  title, startDate, endDate, timezone, venue, city,
}: Props) => (
  <Flex justify="space-between" align="center" gap={8} wrap="wrap">
    <Box minW={0}>
      <Heading fontSize="3xl" fontWeight="semibold">{title}</Heading>
      <Text mt={1} color="gray.600">
        {[asDate(startDate, DateFormat.DAY_OF_WEEK_MONTH_DAY_YEAR), venue, city]
          .filter(Boolean)
          .join(" · ")}
      </Text>
    </Box>
    <Countdown start={startDate} end={endDate} timezone={timezone} />
  </Flex>
)

export default EventHeader
